<template>
    <div class="generate">
        <div class="up-content">
            <div class="item" v-for="(item, i) in pptpageList" :key="i">
                <div class="item-l">
                    {{ i + 1 }}
                    <img :src="item.documentPageUrl" alt="" />
                </div>
                <div class="item-r">{{ item.newVoiceOver }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
const store = useStore();
import { PPTInfo, generateVoiceOver, guideSave, DocEdit } from "@/api";

const fileId = computed(() => store.state.file.fileId);
const upStep = computed(() => store.state.app.upStep);

const isGuide = computed(() => store.state.app.isGuide);

const emits = defineEmits(["changeGenerat"]);
const pageNum = ref(0);

import { fetchSseData } from "@/utils/sse";

watch(
    () => upStep.value,
    async (newValue) => {
        console.log(newValue);
        console.log(newValue);
        console.log(newValue);
        console.log(fileId.value);
        if (newValue == 1) {
            await getPPTInfo();
            !isGuide.value && GenerateText();
        }
    }
);

const pptpageList = ref([]);
onMounted(async () => {
    fileId.value && (await getPPTInfo());
    !isGuide.value && GenerateText();
});
const getPPTInfo = () => {
    //获取PPT详情
    return new Promise((resolve, reject) => {
        PPTInfo({
            documentId: fileId.value,
        }).then((res) => {
            if (res.code == 200) {
                console.log(res);
                pptpageList.value = res.data.documentPageList.map((el) => {
                    el.newVoiceOver = "";
                    el.documentPageId = el.id;
                    return el;
                });

                resolve();
            }
        });
    });
};

const callback = (data) => {
    console.log(data);
    pptpageList.value[pageNum.value].newVoiceOver += data;
};

const success = () => {
    if (pageNum.value < pptpageList.value.length - 1) {
        pageNum.value += 1;
        GenerateText();
    } else {
        emits("changeGenerat", false);
    }
};

const GenerateText = () => {
    fetchSseData(fileId.value, pageNum.value, callback, success);
};


const checkAndSaveVoiceOver = () => {
    let voiceOverPages = [];
    pptpageList.value.forEach((el, i) => {
        let obj = {};
        obj.documentPageId = el.id;
        obj.pageNum = el.pageNum
        obj.voiceOver = el.newVoiceOver;
        voiceOverPages.push(obj);
    });
    console.log(voiceOverPages);

    return new Promise((resolve, reject) => {
        DocEdit({
            voiceOverPages,
            documentId: fileId.value
        })
            .then((res) => {
                resolve();
            })
            .catch(() => {
                reject();
            });
    });
};

defineExpose({ checkAndSaveVoiceOver });
</script>

<style lang="less" scoped>
.generate {
    height: 450px;
    .title-box {
        .m-title {
            font-size: 20px;
            font-weight: 500;
            color: #31302eff;
        }
        .s-title {
            font-size: 12px;
            color: #31302e99;
        }
    }

    .up-content {
        width: 100%;
        height: 600px;
        border-radius: 8px;
        margin-top: 10px;
        position: relative;
        overflow: hidden;
        overflow: auto;
        padding: 0 0 20px 0;
        .item {
            margin-top: 10px;
            display: flex;
            justify-content: space-around;
            .item-l {
                width: 110px;
                display: flex;
                justify-content: space-between;
                // background: rgba(0, 0, 0, 0.1);
                padding: 8px;
                border-radius: 8px;
                img {
                    width: 92px;
                    height: 50px;
                    object-fit: cover;
                    border-radius: 12px;
                    margin-left: 4px;
                }
            }

            .item-r {
                width: 680px;
                height: 126px;
                background: #f0f0f0ff;
                border-radius: 8px;
                padding: 8px;
                overflow: auto;

                &::-webkit-scrollbar-thumb,
                &::-webkit-scrollbar-track {
                    background: transparent;
                }
            }
        }
    }
}
</style>
